import * as React from "react";
import type { SVGProps } from "react";
const SvgDirectiondownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="directiondown_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M554.667 707.84 780.5 482.005a42.667 42.667 0 0 1 60.331 60.331L542.464 840.704a43.093 43.093 0 0 1-60.928 0L183.168 542.336a42.667 42.667 0 1 1 60.33-60.33L469.334 707.84V210.859c0-22.102 19.115-40.022 42.667-40.022s42.667 17.92 42.667 40.022V707.84z"
    />
  </svg>
);
export default SvgDirectiondownIcon;
